import React from 'react'

export default function OverviewList({ items, rowClassName = 'py-2' }) {
  return (
    <div className="w-full">
      {
        items.map(({ label, value, valueClassName = 'text-dark-blue' }, index) => (
          <div
            key={label}
            className={`flex items-start justify-between gap-4 ${rowClassName} ${index < items.length - 1 ? 'border-b border-border-lines' : ''}`}
          >
            <p className="text-secondary">{label}</p>
            <p className={valueClassName}>{value}</p>
          </div>
        ))
      }
    </div>
  )
}
